export class FilingPeriod {
  static readonly MonthNames = ['January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'];
  static readonly NotFiled = 'notfiled';
  private static GetQuarter(date: Date) {
    const month = date.getMonth() + 3;
    return Math.floor(month / 3);
  }
  public static MonthlyId(date: Date): string {
    // return date.getFullYear() + this.MonthNames[date.getMonth()].toLowerCase();
    return 'monthly';
  }
  public static QuarterlyId(date: Date): string {
    return `${date.getFullYear()}q${FilingPeriod.GetQuarter(date)}`;
  }
  public static YearlyId(year: number): string {
    return year.toString();
  }
  public static MonthlyTitle(date: Date): string {
    return `Monthly (${FilingPeriod.MonthNames[date.getMonth()]}-${date.getFullYear()}`;
  }
  public static QuarterlyTitle(date: Date): string {
    return `Quarterly (Q${FilingPeriod.GetQuarter(date)} ${date.getFullYear()})`;
  }
  public static YearlyTitle(year: number) {
    return `Yearly (${year})`;
  }
}
